import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { loginUser } from './authService.js';
import { useAuth } from './AuthProvider.js';
import loginArt from '../assets/login.png';

import '../styles/Login.css';

const Login = () => {
  const { t } = useTranslation();
  const { setCurrentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const redirectTo = location.state?.redirectTo || '/';
  const intent = location.state?.intent || null;
  const inviteId = location.state?.inviteId || null;
  const classroomId = location.state?.classroomId || null;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showRolePicker, setShowRolePicker] = useState(false);

  const handleLogin = async () => {
    try {
      const user = await loginUser(email, password);
      setCurrentUser(user);
      // volta para a rota de origem (ex.: /enem-training)
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(t('login.error'));
    }
  };

  const goToSignup = (role) => {
    setShowRolePicker(false);
    // repassa redirect e intent para o fluxo de cadastro
    if (role === 'student') {
      navigate('/subscribe/student', { state: { redirectTo, intent, inviteId, classroomId } });
    } else {
      navigate('/subscribe/teacher', { state: { redirectTo, intent, inviteId, classroomId } });
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-form-card">
        <div
          className="login-illustration"
          style={{ backgroundImage: `url(${loginArt})` }}
        />

        <div className="login-form-wrapper">
          <h2>{t('login.title')}</h2>

          {error && <p className="error-message">{error}</p>}

          <div className="form-group">
            <label>E-mail</label>
            <input
              type="email"
              value={email}
              placeholder="nome@email.com"
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              required
            />
          </div>

          <div className="form-group">
            <label>{t('login.passwordPlaceholder')}</label>
            <input
              type="password"
              value={password}
              placeholder="••••••••"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            className="login-button"
            onClick={handleLogin}
            disabled={!email.trim() || !password.trim()}
          >
            {t('login.loginButton')}
          </button>

          <div className="signup-section">
            <p>Não possui cadastro?</p>
            <button
              className="signup-link"
              onClick={() => setShowRolePicker(true)}
            >
              Clique aqui
            </button>
          </div>
        </div>
      </div>

      {showRolePicker && (
        <div className="role-modal-backdrop" onClick={() => setShowRolePicker(false)}>
          <div className="role-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Você é…</h3>
            <button className="role-btn student" onClick={() => goToSignup('student')}>
              👩‍🎓 Estudante
            </button>
            <button className="role-btn teacher" onClick={() => goToSignup('teacher')}>
              👨‍🏫 Professor(a)
            </button>
            <button className="close-modal" onClick={() => setShowRolePicker(false)}>
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
